import {
    Component,
    OnInit,
    ViewChild,
    Output,
    EventEmitter,
  } from "@angular/core";
  import { BsModalService } from "ngx-bootstrap/modal";
  import { BsModalRef } from "ngx-bootstrap/modal/bs-modal-ref.service";
  import { IOption } from "ng-select";
  import { NgForm } from "@angular/forms";
  import { NgModule } from "@angular/core";
  import { FormsModule } from "@angular/forms";
  import { Router } from "@angular/router";
  import { HelperService } from "../../services/helper.service";
  
  import Swal from "sweetalert2/dist/sweetalert2.js";
  import { ConfigurationService } from "../../services/configuration.service";
  
  @Component({
    selector: "app-objective-elements-proficiency-master-modal.component",
    templateUrl: "./objective-elements-proficiency-master-modal.component.html",
    providers: [ConfigurationService],
  })
  export class ObjectiveElementsMasterAddProficiencyComponent implements OnInit {
    public masterData: any = {};
    @Output() public ObjectiveRatingMasterReload: EventEmitter<any> =
      new EventEmitter<any>();
  
    formData = {
      description: "",
      //   active: 0,
    };
  
 
    isEdit: number;
    public items: Array<IOption> = [];
    auto_id: number;


    @ViewChild("form") form: NgForm;
    @ViewChild("swalModal") swalModal: any;
    @ViewChild("errorMessageHtml") errorMessageHtml: any;
  
    public successMsg: string = "";
    public htmlErrorMessage: string = "";
    selectedCompanySystemID = this.helperService.getSelectedCompanyId();
    companySystemID = +this.helperService.getSelectedCompanyId();
    // languageSystemID = +this.helperService.getAvailableLang();
  
    activeStatus = [
      { value: 0, label: "Not Active" },
      { value: 1, label: "Active" },
    ];
  
    constructor(
      private router: Router,
      public bsModalRef: BsModalRef,
      private modalService: BsModalService,
      private helperService: HelperService,
      private configurationService: ConfigurationService
    ) {}
  
    showErrorHtml() {
      setTimeout(() => {
        this.errorMessageHtml.show();
      }, 0);
    }
  
    closeModal() {
      this.bsModalRef.hide();
      this.modalService.setDismissReason("questionbank_closed");
    }
  
    closeModalAfterCreate() {
      this.bsModalRef.hide();
      this.modalService.setDismissReason("questionbank_closed");
    }
  
    showSuccessHtml() {
      setTimeout(() => {
        this.swalModal.show();
      }, 0);
    }
  
    ngOnInit() {}
  
    addProficiencyMaster(formData: any) {
      const activeValue = formData.active === undefined ? 0 : formData.active;
      const requestData = {
        description: formData.description,
        active: activeValue,
        company_id: this.companySystemID,
      };
      console.log(requestData);
      let that = this;
  
      that.masterData.companySystemID = that.companySystemID;
      that.configurationService
        .addNewObjectiveProficiency()
        .post(requestData)
        .subscribe(
          (resp: any) => {
            console.log(resp);
            that.masterData = {};
            that.successMsg = "";
            that.successMsg = "Successfully added detailed element master";
            that.showSuccessHtml();
            that.closeModalAfterCreate();
            this.ObjectiveRatingMasterReload.emit();
          },
          (error) => {
            that.htmlErrorMessage = "";
            if (error.status == 500) {
              that.htmlErrorMessage = error.data.message;
              that.showErrorHtml();
            } else if (error.status == 422) {
              that.htmlErrorMessage = that.helperService.serverSideError422(
                error.data.message
              );
              that.showErrorHtml();
              this.ObjectiveRatingMasterReload.emit();
            }
          }
        );
      this.ObjectiveRatingMasterReload.emit();
    }
  
  
  

    editProficiencyMaster() {
      let that = this;
      const requestData = {
        auto_id: that.auto_id,
        items: that.items,
      };
      console.log(requestData);

      that.configurationService
        .editProficiencyMaster()
        .post(requestData)
        .subscribe(
          (resp: any) => {
            console.log(resp);
            that.masterData = {};
            that.successMsg = "";
            that.successMsg = "Successfully updated detailed proficiency master";
            that.showSuccessHtml();
            that.closeModalAfterCreate();
            this.ObjectiveRatingMasterReload.emit();
          },
          (error) => {
            that.htmlErrorMessage = "";
            if (error.status == 500) {
              that.htmlErrorMessage = error.data.message;
              that.showErrorHtml();
            } else if (error.status == 422) {
              that.htmlErrorMessage = that.helperService.serverSideError422(
                error.data.message
              );
              that.showErrorHtml();
              this.ObjectiveRatingMasterReload.emit();
            }
          }
        );
      this.ObjectiveRatingMasterReload.emit();
    }



    getRoleStatusPlaceholder(active: number): string {
      return active === 1 ? 'Active' : 'Not Active';
    }
  
  
    
  }
  


// WEBPACK FOOTER //
// /app/src/app/configuration/objective-elements-proficiency-master-modal/objective-elements-proficiency-master-modal.component.ts